import easing from './easing';

export default function(start, distance, fn, options = {}) {

  var opt = {
      duration: options.duration || 400,
      onComplete: options.onComplete
    },
    timeStart,
    timeElapsed;

  var end = function() {
    fn(start + distance);

    if (typeof opt.onComplete === 'function') {
      opt.onComplete();
    }
  };

  var loop = function(time) {
    timeElapsed = time - timeStart;

    fn(easing(
      timeElapsed, start, distance, opt.duration
    ));

    if (timeElapsed < opt.duration) {
      window.requestAnimationFrame(loop);
    }
    else {
      end();
    }
  };

  window.requestAnimationFrame(time => {
    timeStart = time;
    loop(time);
  });

};



// WEBPACK FOOTER //
// ./src/utils/animation/index.js